import { AxiosInstance } from 'axios';
import { RouteConfig } from 'vue-router';
import { FormData } from '../../requestform';
import { Requests } from '@/pages/profile/modules/mentoring/requestslist';

interface IMentoringRequests {
  $api: AxiosInstance;
  innerMenu: Routes;
  errorMessage: string;
  requests: Requests;
  notNewRequestRoute: boolean;
  successWarning: boolean;
  tutoredId: string;
  updateData: () => void;
  openForm: () => void;
  reset: () => void;
  errorSetup: (err: any) => void;
  closeMessages: () => void;
  toAllRequest: () => void;
  backToForm: () => void;
  getData: () => Promise<void>;
  submitRequestForm: () => Promise<void>;
}

enum RoutsName {
  NEW_REQUESTS = 'profile-newrequests',
}

enum ChildDispatchModuleEnum {
  DISPATCH_CHILD = 'user/getChild',
}

type Routes = Array<RouteConfig>;

export {
  Requests,
  IMentoringRequests,
  AxiosInstance,
  Routes,
  RoutsName,
  FormData,
  ChildDispatchModuleEnum,
};



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/views/requests/types.ts